import { createRouter, createWebHashHistory, RouteRecordRaw, createWebHistory } from 'vue-router';
import useStore from '@/store';
export const constantRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/client'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/index.vue')
  },
  {
    path: '/client',
    name: 'client',
    redirect: '/client/main',
    component: () => import('@/views/index/index.vue'),
    children: [
      {
        path: 'main',
        name: 'main',
        component: () => import('@/views/main/index.vue')
      },
      {
        path: 'customer-service',
        name: 'customer-service',
        component: () => import('@/views/customer-service/index.vue')
      },
      {
        path: 'purchase-account',
        name: 'purchase-account',
        component: () => import('@/views/purchase-account/index.vue')
      },
      {
        path: 'purchase-record',
        name: 'purchase-record',
        component: () => import('@/views/purchase-record/index.vue')
      },
      {
        path: 'amount-recharge',
        name: 'amount-recharge',
        component: () => import('@/views/recharge/index.vue')
      }
    ]
  },
  {
    path: '/pay',
    name: 'pay',
    component: () => import('@/views/recharge/confirm.vue')
  },
  {
    path: '/h5Pay',
    name: 'h5Pay',
    component: () => import('@/views/recharge/components/h5-pay.vue')
  },
  // 管理端
  {
    path: '/admin',
    name: 'admin',
    component: () => import('@/views/admin/index.vue'),
    children: [
      {
        path: 'dataBoard',
        name: 'dataBoard',
        component: () => import('@/views/admin/dataBoard/index.vue'),
        meta: {
          title: '数据看板'
        }
      },
      {
        path: 'user',
        name: 'user',
        component: () => import('@/views/admin/user/index.vue'),
        meta: {
          title: '用户管理'
        }
      },
      {
        path: 'config',
        name: 'config',
        component: () => import('@/views/admin/config/index.vue'),
        meta: {
          title: '系统配置'
        }
      },
      {
        path: 'recharge',
        name: 'recharge',
        component: () => import('@/views/admin/recharge/index.vue'),
        meta: {
          title: '充值管理'
        }
      },
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/admin/order/index.vue'),
        meta: {
          title: '订单管理'
        }
      },
      {
        path: 'goods',
        name: 'goods',
        component: () => import('@/views/admin/goods/index.vue'),
        meta: {
          title: '商品管理'
        }
      },
      {
        path: 'role',
        name: 'role',
        meta: {
          title: '角色管理'
        },
        component: () => import('@/views/admin/role/index.vue')
      },
      {
        path: 'sales',
        name: 'sales',
        meta: {
          title: '销售管理'
        },
        component: () => import('@/views/admin/sales/index.vue')
      },
      {
        path: 'agent',
        name: 'agent',
        meta: {
          title: '代理管理'
        },
        component: () => import('@/views/admin/agent/index.vue')
      }
    ]
  },

  {
    path: '/ban-page',
    name: 'BanPage',
    component: () => import('@/views/ban-page/index.vue'),
    meta: {
      title: 'Ban Page'
    }
  }
  // {
  //   path: '/:pathMatch(.*)*',
  //   name: 'notFound',
  //   component: () => import('@/views/notfound/index.vue')
  // }
];

const router = createRouter({
  history: createWebHistory(), // 使用 history 模式
  routes: constantRoutes,
  // 刷新时，滚动条位置还原
  scrollBehavior: () => ({ left: 0, top: 0 })
});

export default router;
